import { type ButtonHTMLAttributes } from 'react';

type IconButtonVariant = 'translucent' | 'surface';

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: IconButtonVariant;
  size?: number;
  'aria-label': string;
  icon: string;
}

const variantStyles: Record<IconButtonVariant, string> = {
  translucent:
    'bg-static-black/30 backdrop-blur-sm text-static-white hover:bg-static-black/40',
  surface:
    'bg-static-white border border-line-normal text-label-neutral hover:bg-bg-alt',
};

export default function IconButton({
  variant = 'translucent',
  size = 40,
  icon,
  className = '',
  ...props
}: IconButtonProps) {
  return (
    <button
      className={`flex items-center justify-center rounded-full transition-colors cursor-pointer select-none ${variantStyles[variant]} ${className}`}
      style={{ width: size, height: size }}
      {...props}
    >
      <i className={icon} style={{ fontSize: size * 0.45 }}></i>
    </button>
  );
}